
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/all",
      function () {
        return require("private-next-pages/collections/all/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/all"])
      });
    }
  